import React, { useState, useEffect } from "react";
import { Col, Input, Row, Button, Form, Checkbox, Radio } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { createTemplate, updateTemplates } from "../redux/actions";
import AddFieldsComponent from "./addFieldsComponents";
import { UseTemplateFields } from "./useTemplateFields";
import { useNavigate } from "react-router-dom";

const TemplateDetail = ({ isTemplateUpdate, canUpdate }) => {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [currentTemplate, setCurrentTemplate] = useState({});
  const [loading, setLoading] = useState(false);
  const [turnaroundTime, setTurnaroundTime] = useState(false);
  const { createTemplateLoading, currentTemplateObj, updateLoading } =
    useSelector((state) => state.docTypesReducer);
  const navigate = useNavigate();

  const [
    inputFields,
    setInputFields,
    createField,
    deleteField,
    updateField,
    onEditClick,
    createOption,
    updateOption,
    deleteOption,
    onEditClickOption,
  ] = UseTemplateFields();

  let maskFieldPattern = /^[0-9][0-9]-[0-9][0-9]$/;

  const formItemLayout = {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  };
  const onChangeTurnaroundTime = (e) => {
    setTurnaroundTime(e.target.checked);
  };

  const onFinish = (values) => {
    let template_fields = [];

    inputFields.forEach((el) => template_fields.push(el.id));

    const newValues = {
      ...values,
      // numbering_mask: `[NNNNNN]-${values.numbering_mask}-[YY]-[SSSS]`,
    };

    if (isTemplateUpdate) {
      dispatch(
        updateTemplates({
          updateData: { ...newValues, template_fields },
          id: currentTemplateObj.id,
          navigate,
        })
      );
    } else {
      dispatch(createTemplate({ ...newValues, template_fields, navigate }));
    }
  };

  useEffect(() => {
    if (currentTemplateObj?.turnaround_time) {
      setTurnaroundTime(true);
    } else {
      setTurnaroundTime(false);
    }
    // if (currentTemplateObj?.numbering_mask) {
    //   const splitValues = currentTemplateObj.numbering_mask.split("-");
    //   const newObj = {
    //     ...currentTemplateObj,
    //     numbering_mask: `${splitValues[1]}-${splitValues[2]}`,
    //   };
    //   setCurrentTemplate(newObj);
    //   form.setFieldsValue({
    //     ...newObj,
    //   });
    // } else {
    setCurrentTemplate(currentTemplateObj);
    form.setFieldsValue({
      ...currentTemplateObj,
    });
    // }

    setInputFields(currentTemplateObj.template_fields);
  }, [currentTemplateObj]);

  useEffect(() => {
    setLoading(createTemplateLoading);
  }, [createTemplateLoading]);

  return (
    <>
      <Row>
        <Col span={24} className="heading-col">
          <Row align="middle" justify="space-between">
            <Col>
              <div>
                <span className="heading-span">
                  DOCUMENT TEMPLATE {isTemplateUpdate ? " UPDATE" : " CREATION"}
                </span>
              </div>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Form
            {...formItemLayout}
            form={form}
            name="user-details"
            onFinish={onFinish}
            initialValues={currentTemplate}
            scrollToFirstError
            labelWrap={true}
            layout="horizontal"
            className="user-detail-form"
            requiredMark={false}
            disabled={createTemplateLoading}
          >
            <Col
              span={24}
              className={`user-details-section document-type-section`}
            >
              <Row justify="center">
                <Col md={22} lg={22} xl={20} xxl={16}>
                  <Row gutter={[20, 10]}>
                    <Form.Item
                      rules={[
                        {
                          required: true,
                          message: "Required!",
                        },
                      ]}
                      name="template_type"
                    >
                      <Radio.Group>
                        <Col span={12} className="template-type">
                          <Radio value="ims" disabled={!canUpdate}>
                            IMS
                          </Radio>
                        </Col>
                        <Col
                          md={4}
                          lg={4}
                          xl={12}
                          xxl={12}
                          className="template-type projects"
                        >
                          <Radio
                            className="project-radio"
                            disabled={!canUpdate}
                            value="project"
                          >
                            Projects
                          </Radio>
                        </Col>
                      </Radio.Group>
                    </Form.Item>
                  </Row>
                  <Row gutter={[20, 10]}>
                    <Col md={16} lg={14} xl={15} xxl={15}>
                      <Form.Item
                        rules={[
                          {
                            required: true,
                            message: "Required!",
                          },
                        ]}
                        name="name"
                        label="Document Type Name"
                      >
                        <Input
                          disabled={!canUpdate}
                          readOnly={loading}
                          placeholder="Insert Document Type Name"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={[20, 0]}>
                    <Col md={16} lg={14} xl={15} xxl={15}>
                      <Form.Item
                        className="doc-type-number-form-item"
                        rules={[
                          {
                            required: true,
                            message: "Required!",
                          },
                          // {
                          //   pattern: maskFieldPattern,
                          //   message: "Invalid!",
                          // },
                        ]}
                        name="numbering_mask"
                        label="Document Type Numbering Mask"
                      >
                        <Input
                          readOnly={loading}
                          disabled={!canUpdate}
                          // suffix="-[YY]-[SSSS]"
                          // prefix="[NNNNNN]-"
                          // disabled={!isEdit || !canEditEveryThing}
                          placeholder="Insert Document Type Numbering Mask eg.[NNNNNN]-00-02-[YY]-[SSSS]"
                        />
                      </Form.Item>
                    </Col>
                    <div className="text-document-template">
                      <span>
                        [NNNNNN] = Project Number, CC-CC = Classification Code,
                        [YY] = last two digits of the year in which the project
                        was registered, [SSSS] = Sequential Numbering
                      </span>
                    </div>
                  </Row>
                  <Col className="div-text">
                    <div className="checkbox-div">
                      <Form.Item
                        name="turnaround_time"
                        rules={[
                          {
                            required: true,
                            message: "Required!",
                          },
                        ]}
                        valuePropName="checked"
                      >
                        <Checkbox
                          onChange={onChangeTurnaroundTime}
                          disabled={!canUpdate}
                        >
                          Add Document Turnaround Time
                        </Checkbox>
                      </Form.Item>
                    </div>
                  </Col>
                  <Row gutter={[20, 10]}>
                    <Col md={8} lg={8} xl={15} xxl={15}>
                      <Form.Item
                        rules={[
                          {
                            required: turnaroundTime,
                            message: "Required!",
                          },
                        ]}
                        name="completion_days"
                        label="DOCUMENT TURNAROUND TIME FOR COMPLETION (DAYS)"
                      >
                        <Input
                          readOnly={loading}
                          disabled={!turnaroundTime || !canUpdate}
                          placeholder="Insert Number of Days"
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                  <hr />
                  <Col>
                    <AddFieldsComponent
                      inputFields={inputFields}
                      setInputFields={setInputFields}
                      createField={createField}
                      deleteField={deleteField}
                      updateField={updateField}
                      onEditClick={onEditClick}
                      createOption={createOption}
                      updateOption={updateOption}
                      deleteOption={deleteOption}
                      onEditClickOption={onEditClickOption}
                      canUpdate={canUpdate}
                    />
                  </Col>
                  {canUpdate && <hr />}
                  <Row gutter={[20, 20]}>
                    <Col span={24} className="div-text">
                      <div
                        className="checkbox-div"
                        style={{ marginTop: "30px" }}
                      >
                        <Form.Item
                          name="revision_control"
                          valuePropName="checked"
                        >
                          <Checkbox disabled={!canUpdate}>
                            Document Revision Control
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </Col>
                    <Col className="div-text">
                      <div className="checkbox-div">
                        <Form.Item
                          name="distribution_control"
                          valuePropName="checked"
                        >
                          <Checkbox disabled={!canUpdate}>
                            Document Distribution Control
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </Col>
                  </Row>
                </Col>
                {canUpdate && <Col span={23} className="heading-col"></Col>}
                <Col md={24} lg={23} xl={20} xxl={16}>
                  {canUpdate && (
                    <Row gutter={[20, 10]} justify="center">
                      <Row align="middle" justify="center">
                        <Col>
                          <Button
                            type="primary"
                            className="save-btn"
                            size="middle"
                            htmlType="submit"
                            loading={updateLoading || createTemplateLoading}
                          >
                            {isTemplateUpdate ? "Update" : "Save"} Template
                          </Button>
                        </Col>
                      </Row>
                    </Row>
                  )}
                </Col>
              </Row>
            </Col>
          </Form>
        </Col>
      </Row>
      <div className="empty-div"></div>
    </>
  );
};
export default TemplateDetail;
